import {
  FormControl,
  IconButton,
  Input,
  InputAdornment,
} from '@material-ui/core'
import { CSSProperties, ReactNode } from 'react'
import Message from '../Message/Message'

interface Props {
  name: string
  bindValue?: BindValue
  label?: string
  error?: string
  className?: string
  type?: string
  disabled?: boolean
  endAdornment?: boolean
  handleClick?: () => void
  icon?: ReactNode
  autoComplete?: string
  width?: string | number
  style?: CSSProperties
  value?: string
}

const TextInput = ({
  name,
  label,
  bindValue,
  error,
  className,
  type,
  disabled,
  endAdornment,
  handleClick,
  icon,
  autoComplete,
  width,
  style,
  value,
  ...restProps
}: Props) => {
  return (
    <div className={error ? 'error' : ''} style={{ ...style }}>
      <label htmlFor={name}>{label}</label>
      <FormControl className={className} style={{ width }}>
        <Input
          type={type !== '' ? type : 'text'}
          name={name}
          disableUnderline={true}
          value={value ? value : bindValue ? bindValue.value : ''}
          onChange={bindValue && bindValue.onChange}
          disabled={disabled}
          endAdornment={
            endAdornment && (
              <InputAdornment position="end">
                <IconButton onClick={handleClick} disabled={disabled}>
                  {icon}
                </IconButton>
              </InputAdornment>
            )
          }
          autoComplete={autoComplete}
          {...restProps}
        />
      </FormControl>
      {error !== '' && <Message variant="danger">{error}</Message>}
    </div>
  )
}

export default TextInput
